import { Injectable } from '@angular/core';

@Injectable()
export class ToolsService {

  BASE_HREF = '/' + window.location.pathname.split('/')[1];

  constructor() {}

  getColor( data ) {

    if ( data === 0 ) { return 'red'; }

    if ( data === 1 ) { return 'orange'; }

    if ( data >= 2 && data <= 6 ) { return 'blue'; }

    if ( data === 10 ) { return 'green'; }

  }

  getIcon( type ) {

    if ( type === 0 ) { return this.BASE_HREF + '/assets/img/package/0.png'; }

    if ( type === 1 ) { return this.BASE_HREF + '/assets/img/package/warehouse.png'; }

    if ( type === 2 ) { return this.BASE_HREF + '/assets/img/package/aeroplane.png'; }

    if ( type === 3 ) { return this.BASE_HREF + '/assets/img/package/stroller.png'; }

    if ( type === 4 ) { return this.BASE_HREF + '/assets/img/package/forwarded.png'; }

    if ( type === 5 ) { return this.BASE_HREF + '/assets/img/package/forwarded.png'; }

    if ( type === 6 ) { return this.BASE_HREF + '/assets/img/package/delivery.png'; }

    if ( type === 10 ) { return this.BASE_HREF + '/assets/img/package/delivered.png'; }

  }

}



// WEBPACK FOOTER //
// D:/DEV/angular/web-track-correios/src/service/tools.service.ts